import { cloneDeep } from 'lodash'
import createDuck from '../lib/MetagnosticDuck'
import { getProduct,  getProducts } from '../lib/APIClient'
import { emptyTimeTable } from "../timetable/timetable"

const emptyProduct = {
  _id: null,
  city: null,
  type: null,
  backgroundColor: "light",
  backgroundPosition: "right",
  name: "",
  chName: "",
  subtitle: "",
  extraTerms: "",
  description: "",
  longdescription: "",
  address: "",
  rank: 0,
  preciseLocation: {
    address: "",
    latitude: null,
    longitude: null
  },
  price: {
    general: 0,
    ageAware: false,
    perGroup: false,
    agePrices: [],
  },
  priceType: null,
  options: {},
  extras: {},

  firstWarning: {
    text: "",
    icon: "",
    url: ""
  },

  lastWarning: {
    text: "",
    icon: "",
    url: ""
  },

  tags: {},
  timetable: cloneDeep(emptyTimeTable),

  files: {},
  fileNotes: {},
  background: { image: null },
  foreground: { image: null },

  relations: {
    isShy: false,
    includes: [],
    packOf: [],
  }
}

const rehydrate = c => ({
  ...emptyProduct,
  ...c,
  firstWarning: { ...emptyProduct.firstWarning, ...c.firstWarning },
  lastWarning: { ...emptyProduct.lastWarning, ...c.lastWarning },
  relations: { ...emptyProduct.relations, ...c.relations },
})


/**
 *
 */

const duck = createDuck(
  "PRODUCTS",
  getProduct,
  getProducts,
  {
    // #TODO custom remove action (that just says "NOPE")
  },
  emptyProduct,
  null,
  { customRehydrate: rehydrate }
)

export const createProduct = duck.actions.createDoc
export const receiveProducts = duck.actions.receiveCollection
export const receiveProduct = duck.actions.receiveDoc
export const removeProduct = duck.actions.removeDoc
export const fetchProducts = duck.actions.fetchCollection
export const updateProduct = duck.actions.updateDoc

export default duck
